function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Context from './AccordionContext';
import Icon from '../Icon';
var propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,

  /** Disables the accordion item from being expanded or collapsed */
  disabled: PropTypes.bool,

  /** A unique identifier used to track the state of the item being expanded */
  uuid: PropTypes.string.isRequired,

  /** A custom component rendered in place of the default item header */
  HeaderComponent: PropTypes.func,

  /** The title displayed in the accordion item header */
  title: PropTypes.string,

  /** Hides the item within the accordion */
  hidden: PropTypes.bool,

  /** Position of the chevron icon. Default is left */
  iconPosition: PropTypes.oneOf(['left', 'right']),

  /** Size of the accordion control (small: 32px, medium: 40px, large: 48px). Default is medium */
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};

var AccordionItem = function AccordionItem(_ref) {
  var _cx;

  var uuid = _ref.uuid,
      className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      HeaderComponent = _ref.HeaderComponent,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$hidden = _ref.hidden,
      hidden = _ref$hidden === void 0 ? false : _ref$hidden,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size;
  var headingClasses = cx((_cx = {
    accordion__heading: true,
    'paddingleft-md': iconPosition === 'left',
    'paddingright-md': iconPosition === 'right'
  }, _defineProperty(_cx, "height-".concat(size), true), _defineProperty(_cx, 'justify-content-between', iconPosition === 'right'), _cx));
  return /*#__PURE__*/React.createElement(Context.Consumer, null, function (_ref2) {
    var _ref2$expandedItems = _ref2.expandedItems,
        expandedItems = _ref2$expandedItems === void 0 ? [] : _ref2$expandedItems,
        toggleItem = _ref2.toggleItem;
    var expanded = expandedItems.includes(uuid);

    var toggle = function toggle() {
      return toggleItem(uuid);
    };

    var iconLeftClass = expanded ? 'transform-rotate90' : 'transform-rotate0';
    var iconRightClass = expanded ? 'transform-rotate180' : 'transform-rotate0';
    return /*#__PURE__*/React.createElement("li", {
      className: cx('accordion__item', className)
    }, /*#__PURE__*/React.createElement("button", {
      id: "AccordionButton_".concat(uuid),
      className: cx('accordion__button', 'hover-highlight--primary', className),
      "aria-expanded": expanded ? 'true' : 'false',
      "aria-controls": "AccordionChildren_".concat(uuid),
      "aria-disabled": disabled,
      onClick: toggle
    }, HeaderComponent ? HeaderComponent({
      expanded: expanded
    }) : /*#__PURE__*/React.createElement("div", {
      className: headingClasses
    }, iconPosition === 'left' && /*#__PURE__*/React.createElement(Icon, {
      name: "chevron_right",
      className: iconLeftClass
    }), /*#__PURE__*/React.createElement("span", {
      className: "marginleft-md color-text fontweight-500"
    }, title), iconPosition === 'right' && /*#__PURE__*/React.createElement(Icon, {
      name: "chevron_down",
      className: iconRightClass
    }))), /*#__PURE__*/React.createElement("div", {
      id: "AccordionChildren_".concat(uuid),
      className: cx('accordion__children', {
        'display-none': hidden || !expanded,
        'display-block': expanded
      }, className),
      "aria-labelledby": "AccordionButton_".concat(uuid),
      role: "region"
    }, children));
  });
};

AccordionItem.propTypes = propTypes;
AccordionItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AccordionItem",
  "props": {
    "title": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The title displayed in the accordion item header"
    },
    "hidden": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Hides the item within the accordion"
    },
    "iconPosition": {
      "defaultValue": {
        "value": "'left'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'left'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Position of the chevron icon. Default is left"
    },
    "size": {
      "defaultValue": {
        "value": "'medium'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Size of the accordion control (small: 32px, medium: 40px, large: 48px). Default is medium"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Disables the accordion item from being expanded or collapsed"
    },
    "uuid": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "A unique identifier used to track the state of the item being expanded"
    },
    "HeaderComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "A custom component rendered in place of the default item header"
    }
  }
};
export default AccordionItem;